import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { DatePipe, Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GridComponent, RowSelectingEventArgs, RowSelectEventArgs, RowDeselectEventArgs, SelectionSettingsModel, ContextMenuItemModel } from '@syncfusion/ej2-angular-grids';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MovimientoService, MenuFuncionService, MonedaService, AlicuotaIvaService, MedioPagoService, TipoMovimientoService, TenantService, ConsorcioService, ComunidadService, UnidadFuncionalService, ProveedorService, CuentaService, EstadoService } from '../../../../src/app/shared/services';

import { MenuFuncionCodes, Moneda, Movimiento, Cuenta, SearchAlicuotaIvaRequest, SearchMonedaRequest, AlicuotaIva, MedioPago, TipoMovimiento, MedioPagoConstants, DialogConfirmRequest, GetSaldoRequestDto, SearchConsorcioRequest, SearchComunidadRequest, SearchUnidadFuncionalRequest, Comunidad, Consorcio, UnidadFuncional, EstadoConstants, SearchProveedorRequest, Proveedor, TenantEnum, PedidoComunidadRolEnum, SearchCuentaRequest, SearchEstadoRequest, Estado, SaveMovimientoFromDocumentRequestDto, MovimientoAdjunto } from '../../../../src/app/shared/model';
import { SearchMedioPagoRequest, SearchTipoMovimientoRequest, LocalStorageKeys, TenantFeatureFlags, DialogConfirmResponse, MovimientoSaldoPagoModoConstants, DialogCuentaSearchComponentResponseDto, DialogCuentaSearchComponentRequestDto } from '../../../../src/app/shared/model';
import { GenerarMovimientoDeudaDto, GenerarMovimientoPagoDto, SearchMovimientoRequest } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogCuentaSearchComponent } from '../cuenta/components/dialogCuentaSearch.component';

import { MenuEventArgs, BeforeOpenCloseMenuEventArgs  } from '@syncfusion/ej2-angular-navigations';

@Component({
  selector: 'app-movimientoEdit',
  templateUrl: './movimientoEdit.component.html',
  styles: []
})

export class MovimientoEditComponent implements OnInit {

  @ViewChild('deudasPendientesGrid')
  public deudasPendientesGrid: GridComponent;

  formGroup: FormGroup;
  searchDeudaForm: FormGroup;

  isApproving: boolean = false;
  isRejecting: boolean = false;
  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isMonedaSearching: boolean = false;
  isAlicuotaIvaSearching: boolean = false;
  isTipoMovimientoSearching: boolean = false;
  isMedioPagoSearching: boolean = false;
  isFileAttaching: boolean = false;
  isFileAnalyzing: boolean = false;
  isMovimientoDeudaSearching: boolean = false;
  isCuentaImputadaSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;
  isAttachmentSearching: boolean = false;
  isEstadoSearching: boolean = false;
  isRosbaco: boolean = false;
  isZbConstructora: boolean = false;

  newFileDescripcion: string = "";

  canEdit: boolean = false;
  canView: boolean = false;
  canAddPago: boolean = false;
  canAddDeuda: boolean = false;
  canRecurrentes: boolean = false;
  canAnalizarDoc: boolean = false;
  canChangeState: boolean = false;

  debeSeleccionarCuentaImputada: boolean = false;

  showStep1: boolean = false;
  showStep2: boolean = false;

  msgError: string = "";
  item: Movimiento;

  alicuotaIvaList: AlicuotaIva[];
  monedaList: Moneda[];
  estadoList: Estado[];
  defaultMoneda: Moneda;
  medioPagoList: MedioPago[];
  tipoMovimientoList: TipoMovimiento[];
  tipoMovimientoPagoList: TipoMovimiento[];
  deudasPendientesList: any[];
  deudasSeleccionadasList: any[] = [];
  saldoModosList: any[];
  consorcioList: Consorcio[];
  comunidadList: Comunidad[];
  ufList: UnidadFuncional[];
  filteredProveedorList: Proveedor[];
  cuenta: Cuenta;

  tenantFeatureFlags: TenantFeatureFlags;

  totalDisponible: number = 0;
  totalPorPagar: number = 0;

  operacion: number = 0;
  medioPago: MedioPago;
  montoIva: number = 0;
  montoTotal: number = 0;
  montoCuota: number = 0;
  saldoModoSeleccionado: MovimientoSaldoPagoModoConstants;
  cuentaDetalle: Cuenta | null;
  cuentaImputada: Cuenta | null;
  cuentaImputadaSaldo: any;
  rol: PedidoComunidadRolEnum;
  rolTipo = PedidoComunidadRolEnum;

  esUnicaCuentaImputadaDisponible: boolean = false;
  verVersionSimplificada: boolean = true;

  public deudaSelectionOptions?: SelectionSettingsModel;

  public contextMenuItems: ContextMenuItemModel[];

  private readonly gridColumns = [
    { field: 'FechaMovimiento', headerText: 'Fecha Movimiento' },
    { field: 'FechaVencimiento', headerText: 'Vencimiento' },
    { field: 'CuentaImputada', headerText: 'Referencia' },
    { field: 'Detalle', headerText: 'Detalle' },
    { field: 'TipoMovimientoNombre', headerText: 'Tipo' },
    { field: 'Monto', headerText: 'Total' },
    { field: 'Saldo', headerText: 'Pendiente' },
    { field: 'SaldoConvertido', headerText: 'Saldo Convertido' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private menuService: MenuFuncionService,
    private monedaService: MonedaService,
    private alicuotaIvaService: AlicuotaIvaService,
    private medioPagoService: MedioPagoService,
    private tipoMovimientoService: TipoMovimientoService,
    private tenantService: TenantService,
    private consorcioService: ConsorcioService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private proveedorService: ProveedorService,
    private movimientoService: MovimientoService,
    private estadoService: EstadoService,
    private cuentaService: CuentaService
  ) {
    this.deudaSelectionOptions = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_EDIT);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_LIST);

            this.canAddPago = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_PAGO);
            this.canAddDeuda = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_DEUDA);
            this.canRecurrentes = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_RECURRENTES);
            this.canAnalizarDoc = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_ANALISIS_DOCUMENTO);
            this.canChangeState = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_CHANGE_STATE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
    this.contextMenuItems = this.sharedFunctions.initializeContextMenu(this.gridColumns);
  }

  loadView() {
    this.isRosbaco = this.sharedFunctions.isRosbacoUser();
    this.buildForm();

    if (!this.canAddPago || !this.canAddDeuda) {
      if (this.canAddPago)
        this.onPagoClick(true);

      if (this.canAddDeuda)
        this.onDeudaClick(true);
    }

    this.getMediosPago();
    this.getMonedas();
    this.getSaldoPagoModos();
    this.getComunidades();
    this.getEstados();
    this.getAlicuotaIva();

    this.loadEntity();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'FechaMovimiento': [new Date(), Validators.required],
      'FechaVencimiento': [new Date()],
      'EstadoId': [EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO, Validators.required],
      // 'CuentaDetalleId': [null],
      'TipoMovimientoId': [0, Validators.required],
      'MedioPagoId': [null],
      'AlicuotaIvaId': [null],
      'Moneda': [null],
      'MontoBase': [0, Validators.required],
      'MontoPercepciones': [0, Validators.required],
      'Detalle': [null, [Validators.required, Validators.maxLength(100)]],
      'Observacion': [null, Validators.maxLength(300)],
      'NroComprobante': [null, Validators.maxLength(100)],

      'EsRecurrente': [false, Validators.required],
      'PeriodicidadRecurrencia': [null],

      //Solo para deudas
      'CantidadCuotas': [1, Validators.min(1)],
      'FechaInicioCuota': [new Date()],
      'DiasRepeticionCuotas': [30],
      'PorcentajeAjusteCuota': [0, [Validators.min(0), Validators.max(100)]],
      'AplicarAjusteIncremental': [false],
      'MovimientoPagado': [false],
      'TipoMovimientoPagoId': [null],
      'MontoPagado': [null]
    });

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchDeudaForm = this.formBuilder.group({
      'FechaMovimientoDesde': [null],
      'FechaMovimientoHasta': [new Date()],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [null],
      'Detalle': [null],
      'MonedaId': [null],

      'PedidoId': [null],
      'Contrato': [null],

      'NroDocumento': [null],
      'MailContacto': [null],
      'MovilContacto': [null],
      'Usuario': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'UnidadFuncionalId': [null],
      'Proveedor': [null],

      'VerSoloAsociadosAUfs': [false]
    });

    var filtros = this.sharedFunctions.getReporteFiltros("app-buscadorMovimientosDeuda");
    if (filtros != null) {
      this.searchDeudaForm.patchValue(filtros);
      if (filtros.ComunidadId != null && filtros.ComunidadId > 0)
        this.onDeudaFiltroUfComunidadSelect(false);
    }
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isApproving || this.isRejecting);
  }

  getEstados() {
    if (!this.canChangeState)
      return false;

    var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchMovimientoEstados(r).subscribe(data => {
      this.isEstadoSearching = false;
      this.estadoList = data?.result?.filter(f => f.Id != EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO);

      this.formGroup.get('EstadoId')?.setValue(EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO);
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;

      this.selectMonedaDefault();
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  selectMonedaDefault() {
    if (this.monedaList != null && this.monedaList.length == 1 && (this.item?.MonedaId == null || this.item.MonedaId <= 0)) {
      this.formGroup.get('Moneda')?.setValue(this.monedaList[0]);
      this.onMonedaSelect();
    }
  }

  getMediosPago() {
    var r = new SearchMedioPagoRequest(null, null, true, "Nombre", null, null, true);
    this.isMedioPagoSearching = true;

    this.medioPagoService.search(r).subscribe(data => {
      this.isMedioPagoSearching = false;
      this.medioPagoList = data?.result;

      this.selectMedioPagoDefault();
    },
    (err: HttpErrorResponse) => {
      this.isMedioPagoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  selectMedioPagoDefault() {
    if (this.medioPagoList != null && (this.item?.MedioPagoId == null || this.item.MedioPagoId <= 0)) {
      this.formGroup.get('MedioPagoId')?.setValue(null);

      if (this.medioPagoList.length == 1)
        this.formGroup.get('MedioPagoId')?.setValue(this.medioPagoList[0]?.Id);
      else
        this.formGroup.get('MedioPagoId')?.setValue(this.medioPagoList.find(f => f.Id == MedioPagoConstants.Efectivo)?.Id);
    }

    this.onMedioPagoSelect();
  }

  getTiposMovimientos() {
    var r = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, null, null, true);
    this.isTipoMovimientoSearching = true;

    this.tipoMovimientoService.search(r).subscribe(data => {
      this.isTipoMovimientoSearching = false;

      this.tipoMovimientoList = data?.result?.filter(f => f.Signo == this.operacion);
      if (this.operacion < 0)
        this.tipoMovimientoPagoList = data?.result?.filter(f => f.Signo > 0);

      this.selectTipoMovimientoDefault();
    },
    (err: HttpErrorResponse) => {
      this.isTipoMovimientoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  selectTipoMovimientoDefault() {
    if (this.tipoMovimientoList != null && this.tipoMovimientoList.length == 1 && (this.item?.TipoMovimientoId == null || this.item.TipoMovimientoId <= 0)) {
      this.formGroup.get('TipoMovimientoId')?.setValue(this.tipoMovimientoList[0]?.Id);
    }
  }

  getSaldoPagoModos() {
    this.saldoModosList = [
      { Id: MovimientoSaldoPagoModoConstants.IngresoManual, Nombre: "Ingresar montos a mano" },
      { Id: MovimientoSaldoPagoModoConstants.SaldarTodo, Nombre: "Seleccionar deudas hasta alcanzar el monto pagado" }
    ];

    this.saldoModoSeleccionado = MovimientoSaldoPagoModoConstants.IngresoManual;
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null, null, true, "Nombre", null, null, null, null, true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;

      this.selectAlicuotaIvaDefault();
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  selectAlicuotaIvaDefault() {
    if (this.alicuotaIvaList != null && this.operacion < 0 && (this.item?.AlicuotaIvaId == null || this.item.AlicuotaIvaId <= 0)) {
      this.formGroup.get('AlicuotaIvaId')?.setValue(null);

      if (this.alicuotaIvaList.length == 1)
        this.formGroup.get('AlicuotaIvaId')?.setValue(this.alicuotaIvaList[0]?.Id);
      else
        this.formGroup.get('AlicuotaIvaId')?.setValue(this.alicuotaIvaList.find(f => f.Porcentaje == 0)?.Id);
    }

    this.onAlicuotaIvaSelect();
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return;

    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getProveedoresAutocomplete() {
    this.searchDeudaForm.get('Proveedor')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredProveedorList = [];
          this.isProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.isProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredProveedorList = data.result;
        else
          this.filteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  onDeudaFiltroUfComunidadSelect(clearUf: boolean = true) {
    if (!this.tenantFeatureFlags?.HabilitarGestionUf)
      return;

    if (clearUf)
      this.searchDeudaForm?.get("UnidadFuncionalId")?.setValue(null);

    var cId = this.searchDeudaForm?.get("ComunidadId")?.value;
    if (cId == null || cId <= 0) {
      this.ufList = [];
      return false;
    }

    var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
    this.isUnidadesFuncionalesSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.ufList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onPagoClick(seleccionoVersionSimplificada: boolean) {
    this.operacion = 1;
    this.showStep1 = true;
    this.verVersionSimplificada = seleccionoVersionSimplificada;

    this.cuentaImputada = null;
    this.cuentaDetalle = null;
    this.cuentaImputadaSaldo = null;
    this.deudasPendientesList = [];

    this.searchGastosPendientes();

    this.getConsorcios();
    this.getComunidades();
    this.getProveedoresAutocomplete();

    this.getTiposMovimientos();

    this.selectAlicuotaIvaDefault();
    this.selectMonedaDefault();
    this.selectMedioPagoDefault();
    this.selectTipoMovimientoDefault();
  }

  onDeudaClick(seleccionoVersionSimplificada: boolean) {
    this.operacion = -1;
    this.showStep1 = true;
    this.verVersionSimplificada = seleccionoVersionSimplificada;

    this.showStep2 = false;
    this.deudasPendientesList = [];

    this.cuentaImputada = null;
    this.cuentaDetalle = null;
    this.cuentaImputadaSaldo = null;

    this.getTiposMovimientos();

    this.selectAlicuotaIvaDefault();
    this.selectMonedaDefault();
    this.selectMedioPagoDefault();
    this.selectTipoMovimientoDefault();

    this.verificarCuentaImputadaUnica();
  }

  onMedioPagoSelect() {
    const medioPagoEncontrado = this.medioPagoList?.find(f => f.Id == this.formGroup.get("MedioPagoId")?.value);
    if (medioPagoEncontrado)
     this.medioPago = medioPagoEncontrado

    if (this.medioPago?.Id != MedioPagoConstants.CreditoEnCuenta)
      this.cuentaImputada = null;

    this.debeSeleccionarCuentaImputada = this.medioPago?.Id == MedioPagoConstants.CreditoEnCuenta;
  }

  onAlicuotaIvaSelect() {
    this.calcularMontos();
  }

  onMontoBaseChange() {
    this.formGroup.get("MontoBase")?.markAsTouched();
    this.calcularMontos();
  }

  calcularMontos() {
    var importeBase = (this.formGroup.get("MontoBase")?.value ?? 0);
    var importePercepciones = (this.formGroup.get("MontoPercepciones")?.value ?? 0) * (this.operacion > 0 ? -1 : 1);

    var alicuota = this.alicuotaIvaList?.find(f => f.Id == this.formGroup.get("AlicuotaIvaId")?.value);
    if (alicuota != null && alicuota.Id > 0)
      this.montoIva = (importeBase * (alicuota.Porcentaje / 100));
    else
      this.montoIva = 0;

    this.montoTotal = importeBase + this.montoIva + (importePercepciones * (this.formGroup.get("CantidadCuotas")?.value ?? 1));
    this.montoCuota = (this.montoTotal * (1 + ((this.formGroup.get('PorcentajeAjusteCuota')?.value ?? 0) / 100))) / (this.formGroup.get("CantidadCuotas")?.value ?? 1);

    this.calcularTotalPorPagar();
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          if (this.canView || this.canEdit) {
            this.isSearching = true;
            this.movimientoService.get(id).subscribe(data => {
              this.isSearching = false;
              if (data != null && data.Success) {
                this.canView = true;
                this.item = data.Result;

                if (this.item != null && this.item.Id > 0) {
                  this.loadAttachments(this.item.Id);
                  this.formGroup.patchValue(this.item);
                  // this.loadCuenta();
                }
                else {
                  this.canView = false;
                  this.msgError = "No se encontró el movimiento seleccionado.";
                }
              }
              else {
                this.canView = false;
                this.msgError = "Ocurrió un error al intentar obtener los datos del movimiento.";
              }
            },
            (err: HttpErrorResponse) => {
              this.canView = false;
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else {
            this.canView = false;
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else {
          this.canView = false;
          this.msgError = "Item no válido.";
        }
      }
      else {
        if (this.canAddDeuda || this.canAddPago) {
          this.canView = true;
          this.item = new Movimiento(0, null, null, null, null, null, null, null, null, null, null, null, null, new Date(), new Date(), null, null, null, null, null, null,
            0, null, null, null, null, null, null, null, null, null, [], null, null, null, false);
          this.formGroup.patchValue(this.item);
        }
        else {
          this.canView = false;
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  loadAttachments(id) {
    this.isAttachmentSearching = true;
    this.movimientoService.getAttachments(id).subscribe(data => {
      this.isAttachmentSearching = false;
      this.item.Adjuntos = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isAttachmentSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getErrorFechaMovimiento() {
    return this.formGroup.get('FechaMovimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoMovimientoId() {
    return this.formGroup.get('TipoMovimientoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorEstadoId() {
    return this.formGroup.get('EstadoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorDetalle() {
    var v = this.formGroup.get('Detalle');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMonedaId() {
    return this.formGroup.get('Moneda')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMontoBase() {
    return this.formGroup.get('MontoBase')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMontoPercepciones() {
    return this.formGroup.get('MontoPercepciones')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErroNroComprobante() {
    var v = this.formGroup.get('NroComprobante');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMedioPagoId() {
    return this.formGroup.get('MedioPagoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorAlicuotaIvaId() {
    return this.formGroup.get('AlicuotaIvaId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorObservacion() {
    var v = this.formGroup.get('Observacion');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorCantidadCuotas() {
    var v = this.formGroup.get('CantidadCuotas');
    if (v?.hasError('min'))
      return 'Debe ingresar un valor mayor a 0';
    return '';
  }

  getErrorFechaInicioCuota() {
    var v = this.formGroup.get('FechaInicioCuota');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorDiasRepeticionCuotas() {
    var v = this.formGroup.get('DiasRepeticionCuotas');
    if (v?.hasError('maxlength'))
      return 'Límite de 5 caracteres alcanzado';
    return '';
  }

  getErrorPorcentajeAjusteCuota() {
    var v = this.formGroup.get('PorcentajeAjusteCuota');
    if (v?.hasError('min'))
      return 'El porcentaje debe ir entre 0 y 100';
    if (v?.hasError('max'))
      return 'El porcentaje debe ir entre 0 y 100';
    return '';
  }

  onStep1() {
    if (this.operacion > 0) {
      this.showStep2 = true;
      // this.searchGastosPendientes();

      // this.getConsorcios();
      // this.getComunidades();

      // this.searchDeudaForm.get("UnidadFuncionalId")?.setValue(null);
    }
  }

  onMonedaSelect() {
    if (this.operacion > 0 && this.showStep2) {
      this.searchGastosPendientes();
      this.verificarCuentaImputadaUnica();
    }
  }

  clearDeudaDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.searchDeudaForm.get(formFieldName) != null && this.searchDeudaForm.get(formFieldName)?.value)
            this.searchDeudaForm.get(formFieldName)?.setValue(null);
    }
  }

  searchGastosPendientes() {
    if (this.operacion < 0)
      return false;

    this.sharedFunctions.setReporteFiltros("app-buscadorMovimientosDeuda", this.searchDeudaForm.getRawValue());
    var search = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, true, false, null);

    search = {
      ...search,
      ...this.searchDeudaForm.value,
      ... {
        Estados: [ EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO.toString() ],
        VerSoloDeudasPendientes: true,
        VerSoloActivos: true,
        MonedaConversionId: this.formGroup.get("Moneda")?.value?.Id,
        ProveedorId: this.searchDeudaForm.get("Proveedor")?.value?.Id
      }
    }

    this.isMovimientoDeudaSearching = true;
    this.movimientoService.search(search).subscribe(data => {
      this.isMovimientoDeudaSearching = false;
      this.deudasPendientesList = data?.result;

      for (var i=0; i<this.deudasPendientesList.length; i++)
        this.deudasPendientesList[i].MontoPago = 0;

      this.calcularTotalPorPagar();
    },
    (err: HttpErrorResponse) => {
      this.isMovimientoDeudaSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onSaldoModoChange() {
    if (this.esIngresoManual()) {
      var montos = this.deudasPendientesList?.filter(f => f.MontoPago != null && f.MontoPago > 0)
      if (montos != null && montos.length > 0) {
        for (var i=0; i<montos.length; i++)
          montos[i].MontoPago = 0;
      }
    }
    else {
      var seleccionados = this.deudasPendientesList?.filter(f => f.Seleccionado == true);
      if (seleccionados != null && seleccionados.length > 0) {
        for (var i=0; i<seleccionados.length; i++)
          seleccionados[i].Seleccionado = false;
      }
    }

    this.totalPorPagar = 0;
  }

  onDeudaDataBound(args: any) {
    var seleccionados = this.deudasPendientesList?.filter(f => f.Seleccionado == true);

    // Restaurar la selección de filas
    if (seleccionados != null && seleccionados.length > 0) {
      var pageRows = this.deudasPendientesGrid.getRowsObject();
      if (pageRows != null && pageRows.length > 0) {
        var indexes : number[] = [];
        for (var i=0; i<pageRows.length; i++) {
          if (seleccionados.some(f => f.Id == (pageRows[i].data as any).Id))
            indexes.push(pageRows[i].index);
        }

        if (indexes != null && indexes.length > 0)
          this.deudasPendientesGrid.selectRows(indexes);
      }
    }
  }

  public onDeudaRowSelect(args: RowSelectEventArgs): void {
    if (args.isHeaderCheckboxClicked) {
      // var multiSelection = this.deudasPendientesGrid.getRowsObject();
      // if (multiSelection != null && multiSelection.length > 0) {
      //   for (var i=0; i<multiSelection.length; i++)
      //     this.deudasPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = true;
      // }
      for (var i=0; i<this.deudasPendientesList.length; i++)
        this.deudasPendientesList[i].Seleccionado = true;
    }
    else {
      if (args?.data != null && (args?.data as any).Id != null)
        this.deudasPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = true;
    }

    this.calcularTotalPorPagar();
  }

  onDeudaRowDeselected(args: RowDeselectEventArgs ): void {
    //Solo cuando hace click en el checkbox de la grilla deselecciona
    if (args.isHeaderCheckboxClicked) {
      // var multiSelection = this.deudasPendientesGrid.getRowsObject();
      // if (multiSelection != null && multiSelection.length > 0) {
      //   for (var i=0; i<multiSelection.length; i++)
      //     this.deudasPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = false;
      // }
      for (var i=0; i<this.deudasPendientesList.length; i++)
        this.deudasPendientesList[i].Seleccionado = false;
    }
    else {
      if (args?.data != null  && (args?.data as any).Id != null && args?.target?.className == "e-frame e-icons e-uncheck")
        this.deudasPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = false;
    }

    this.calcularTotalPorPagar();
  }

  onGuardar() {

    var importe = this.formGroup.get("MontoBase")?.value;
    if (importe == 0) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: new DialogConfirmRequest(
          "Confirmación de Movimiento",
          "Cargó un importe con valor 0. ¿Está seguro que desea continuar con la operación?",
          "Sí",
          "No"
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          if (this.operacion > 0)
            this.generarPago();
          else
            this.generarDeuda();
        }
      });
    }
    else {
      if (this.operacion > 0)
        this.generarPago();
      else
        this.generarDeuda();
    }
  }

  generarPago() {

    if (this.totalDisponible > 0) {
      var seleccionoCuenta = this.cuentaImputada != null && ((this.cuentaImputada.ProveedorId ?? 0) + (this.cuentaImputada.ConsorcioId ?? 0) + (this.cuentaImputada.ComunidadId ?? 0) + (this.cuentaImputada.UnidadFuncionalId ?? 0) + (this.cuentaImputada.PersonaId ?? 0) > 0);

      if (!this.isRosbaco) {
        const dialogRef = this.dialog.open(DialogConfirmComponent, {
          data: new DialogConfirmRequest(
            "Alerta de Saldo Sobrante",
            "<b>Tiene aún disponible un saldo de " + this.formGroup.controls['Moneda']?.value?.Codigo + " " + this.totalDisponible.toLocaleString('en') + ".</b><br>" +
              "En caso de no querer usarlo, " + (seleccionoCuenta ? "se asignará el sobrante a la misma cuenta seleccionada" : "deberá definir una cuenta donde quedará guardado ese monto") + ".<br><br>" +
              "¿Desea guardar el excedente y asociarlo a una cuenta?",
            "Sí, guardar el sobrante",
            "No, voy a asignarlo a deudas"
          )
        });

        dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
          if (result != null && result.Accepted) {
            if (seleccionoCuenta)
              this.doGeneracionPago();
            else
              this.openDialogCuentaParaAcreditarSobranteSearch();
          }
        });
      }
      else {
        if (seleccionoCuenta)
          this.doGeneracionPago();
        else
          this.openDialogCuentaParaAcreditarSobranteSearch();
      }
    }
    else
      this.doGeneracionPago();
  }

  doGeneracionPago() {
    var r = new GenerarMovimientoPagoDto(0, null, null, null, null, null, null, null, null, null, new Date(), null, null, null, null, null, null, [], []);

    var deudas : any[] = [];
    if (this.saldoModoSeleccionado == MovimientoSaldoPagoModoConstants.IngresoManual)
      deudas = this.deudasPendientesList?.filter(f => f.MontoPago != null && f.MontoPago > 0);
    else
      deudas = this.deudasPendientesList.filter(f => f.Seleccionado == true);

    if (!this.esEstadoPendiente())
      this.formGroup.get("FechaVencimiento")?.setValue(null);

    if (this.cuentaImputada != null)
      this.cuentaImputada.MonedaId = (this.formGroup.get("Moneda")?.value?.Id ?? 0);

    if (this.cuentaDetalle != null)
      this.cuentaDetalle.MonedaId = (this.formGroup.get("Moneda")?.value?.Id ?? 0);

    r = {
      ...this.formGroup.value,
      ... {
        Id: (this.item?.Id ?? 0),
        ModoSaldado: this.saldoModoSeleccionado,
        MonedaId: (this.formGroup.get("Moneda")?.value?.Id ?? 0),
        CuentaImputadaId: this.cuentaImputada?.Id,
        CuentaImputada: this.cuentaImputada,
        CuentaDetalleId: this.cuentaDetalle?.Id,
        CuentaDetalle: this.cuentaDetalle,
        MovimientosDeuda: deudas,
        Adjuntos: this.item?.Adjuntos
      }
    };
    // console.log('generarPago request: ', r);

    this.isSaving = true;
    this.movimientoService.generarPago(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result) {
        // this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.mostrarConfirmacionCierre(data.Result);
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  mostrarConfirmacionCierre(movimientoId: number) {
    var mensaje = "";
    if (this.operacion > 0)
      mensaje = (this.isRosbaco ? "ingreso." : "pago.");
    else
      mensaje = (this.isRosbaco ? "egreso." : "gasto.");

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Movimiento Generado Exitosamente!",
        "Se generó éxitosamente el " + mensaje +" ¿Desea cargar un nuevo movimiento?",
        "Sí",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted)
        this.sharedFunctions.reloadCurrentRoute();
      else
        this.router.navigate(['movimiento-view', movimientoId]);
    });
  }

  openDialogCuentaParaAcreditarSobranteSearch() {
    if (this.isProcessing())
        return;

    this.cuentaImputada = null;

    var monedaId = this.formGroup.get("Moneda")?.value?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta crédito", "Error");
      return false;
    }

    //Dialog para seleccionar a que cuenta se le asignara el saldo excedente de un pago (no aplica para deudas)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
      width: '90%',
      data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, false, false, true, true, true, this.formGroup.get("Moneda")?.value?.Id, this.formGroup.get("Moneda")?.value?.Codigo, false)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {

        var cargoCuenta = this.checkCuentaImputada(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaImputada = result.Item;
        this.doGeneracionPago();
      }
    });
  }

  openDialogCuentaCreditoSearch() {
    if (this.isProcessing())
        return;

    var monedaId = this.formGroup.get("Moneda")?.value?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta crédito", "Error");
      return false;
    }

    //Dialog para seleccionar desde que cuenta se tomara credito excedente para realizar un pago (no aplica en deudas)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
        width: '90%',
        data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, false, false, true, true, true, monedaId, this.formGroup.get("Moneda")?.value?.Codigo, true)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var cargoCuenta = this.checkCuentaImputada(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaImputadaSaldo = { Moneda: "Sin saldo disponible", Saldo: null };
        this.cuentaImputada = result.Item;

        if (this.cuentaImputada != null && this.cuentaImputada.Id > 0) {
          var r = new GetSaldoRequestDto(this.cuentaImputada.Id, null, null, null, null, null, null);
          this.isCuentaImputadaSearching = true;
          this.movimientoService.getSaldo(r).subscribe(data => {
            this.isCuentaImputadaSearching = false;
            if (data != null && data.Success && data.Result != null && data.Result.Saldos != null && data.Result.Saldos.length > 0) {
              this.cuentaImputadaSaldo = { Saldo: data.Result.Saldos[0].SaldoAFavor, Moneda: data.Result.Saldos[0].Moneda };

              this.formGroup.get("Moneda")?.setValue(this.monedaList.find(f => f.Codigo == data.Result.Saldos[0].Moneda));
              this.formGroup.get("Monto")?.setValue(data.Result.Saldos[0].SaldoAFavor);
            }
          },
          (err: HttpErrorResponse) => {
            this.isCuentaImputadaSearching = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
      }
    });
  }

  openDialogCuentaDeudaSearch() {
    if (this.isProcessing())
        return;

    var monedaId = this.formGroup.get("Moneda")?.value?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta a la cual asociar la deuda", "Error");
      return false;
    }

    //Dialog para seleccionar a que cuenta se le imputa un movimiento de deuda (no se usa en pagos)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
        width: '90%',
        data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, false, false, true, true, true, monedaId, this.formGroup.get("Moneda")?.value?.Codigo, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var cargoCuenta = this.checkCuentaImputada(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaImputada = result.Item;
      }
    });
  }

  verificarCuentaImputadaUnica() {
    this.esUnicaCuentaImputadaDisponible = false;

    //Traigo las primeras 3 cuentas disponibles que tenga el usuario. Si viene solo 1, la asigno como default
    var r = new SearchCuentaRequest(3, 0, true, "", null, null, null, null, null, this.formGroup.get("Moneda")?.value?.Id, null, null, null,
      null, null, null, true, null, false, true);

    this.cuentaService.search(r).subscribe(data => {
      var cuentaList = data?.result;
      if (cuentaList != null && cuentaList.length == 1) {
        this.esUnicaCuentaImputadaDisponible = true;
        this.cuentaImputada = cuentaList[0];
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    })
  }

  getCuentaDefault() {
    var cuentaResult = new Cuenta(
      0,
      "", true,
      this.monedaList[0]?.Id,
      null, null, null, null, null, null, null, true,
      null,
      null,
      null,
      null,
      this.comunidadList[0]?.Id,
      this.comunidadList[0]?.Nombre,
      null,
      null,
      null,
      null,
    );

    return cuentaResult;
  }

  openDialogCuentaDetalleSearch() {
    if (this.isProcessing())
        return;

    var monedaId = this.formGroup.get("Moneda")?.value?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta a la cual asociar la deuda", "Error");
      return false;
    }

    //Dialog para seleccionar a que cuenta se le imputa un movimiento de deuda (no se usa en pagos)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
      width: '90%',
      data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, true, true, false, false, false, monedaId, this.formGroup.get("Moneda")?.value?.Codigo, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var cargoCuenta = this.checkCuentaDetalle(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaDetalle = result.Item;
      }
    });
  }

  checkCuentaImputada(datosCuenta) {
    return (datosCuenta != null && ((datosCuenta.ComunidadId ?? 0) + (datosCuenta.ConsorcioId ?? 0) + (datosCuenta.UnidadFuncionalId ?? 0) > 0));
  }

  checkCuentaDetalle(datosCuenta) {
    if (datosCuenta == null)
      return false;

    if ((datosCuenta.ProveedorId ?? 0) + (datosCuenta.PersonaId ?? 0) > 0)
      return true;
    else {
      if ((datosCuenta.PersonaId ?? 0) == 0 && datosCuenta.Persona != null)
        return true;
    }

    return false;
  }

  cleanCuentaDetalle() {
    this.cuentaDetalle = null;
  }

  cleanCuentaImputada() {
    this.cuentaImputadaSaldo = null;
    this.cuentaImputada = null;
  }

  cleanCuentaDeuda() {
    this.cuentaImputada = null;
  }

  onMovimientoPagadoChange() {
    if (this.formGroup.get('MovimientoPagado')?.value == true)
      this.formGroup.get('MontoPagado')?.setValue(this.montoTotal);
    else
      this.formGroup.get('MontoPagado')?.setValue(null);
  }

  generarDeuda() {
    var r = new GenerarMovimientoDeudaDto(0, null, null, null, null, null, null, null, null, new Date(), null, 0, 0, 1, null, 0, 0, false, false, null, null, null, null, null, false, 0, []);

    if (this.cuentaImputada != null)
      this.cuentaImputada.MonedaId = (this.formGroup.get("Moneda")?.value?.Id ?? 0);

    if (this.cuentaDetalle != null)
      this.cuentaDetalle.MonedaId = (this.formGroup.get("Moneda")?.value?.Id ?? 0);

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        MonedaId: (this.formGroup.get("Moneda")?.value?.Id ?? 0),
        CuentaImputadaId: (this.cuentaImputada?.Id ?? 0),
        CuentaImputada: this.cuentaImputada,
        CuentaDetalleId: this.cuentaDetalle?.Id,
        CuentaDetalle: this.cuentaDetalle,
        Adjuntos: this.item?.Adjuntos
      }
    };
    // console.log('generarDeuda request: ', r);

    this.isSaving = true;
    this.movimientoService.generarDeuda(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result && data.Result.length > 0) {
        this.mostrarConfirmacionCierre(data.Result[0]);
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  onFileAttachedDelete(item: any) {
    if (item.Id > 0)
      this.onExistingFileAttachedDelete(item);
    else
      this.onNewFileAttachedDelete(item);
  }

  onExistingFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.NombreDocumento == item.NombreDocumento);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (this.item.Adjuntos == null)
        this.item.Adjuntos = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
          setTimeout(() => {
            this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          }, 100);
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.movimientoService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                data.Result.Archivos[i].Descripcion = this.newFileDescripcion;
                this.item.Adjuntos.push(data.Result.Archivos[i]);
                this.newFileDescripcion = "";
              }
            }
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

  esIngresoManual() {
    return (this.saldoModoSeleccionado == MovimientoSaldoPagoModoConstants.IngresoManual);
  }

  calcularTotalPorPagar() {
    this.totalPorPagar = 0;
    if (this.esIngresoManual()) {
      if (this.deudasPendientesList != null && this.deudasPendientesList.length > 0)
        this.totalPorPagar += this.deudasPendientesList.filter(f => f.MontoPago != null && f.MontoPago > 0)?.reduce((total, item) => total + parseFloat(item.MontoPago.toString()), 0);
    }
    else {
      if (this.deudasPendientesGrid != null) {
        var filasSeleccionadas = this.deudasPendientesList?.filter(f => f.Seleccionado == true);
        if (filasSeleccionadas != null && filasSeleccionadas.length > 0)
          this.totalPorPagar += filasSeleccionadas.reduce((total, item) => total - item.SaldoConvertido, 0);
      }
    }

    this.totalDisponible = (this.montoTotal ?? 0) - (this.totalPorPagar ?? 0);

    if (!this.formGroup.controls['MontoBase'].touched)
      this.formGroup.get("MontoBase")?.setValue(this.totalPorPagar);

    return this.totalPorPagar;
  }

  onDeudaGridFieldChange(movimientoId: number, value: any) {
    // console.log("movimientoId: " + movimientoId + " - value: " + value);
    if (movimientoId != null && movimientoId > 0 && this.deudasPendientesList != null) {
      var index = this.deudasPendientesList?.findIndex(f => f.Id == movimientoId);
      if (index >= 0) {
        this.deudasPendientesList[index].MontoPago = value;
        this.deudasPendientesGrid.refresh();

        this.calcularTotalPorPagar();
      }
    }
  }

  esEstadoPendiente() {
    return this.formGroup?.get('EstadoId')?.value == EstadoConstants.ESTADO_MOVIMIENTO_PENDIENTE;
  }

  onFileAttachForAnalyze(event: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Confirmación de Operación",
        "Si adjunta un archivo para analizar, puede que pise alguno los datos que haya completado del movimiento.<br/><br/>¿Está seguro que desea continuar con la operación?",
        "Sí",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.doFileAttachForAnalysis(event);
      }
    });
  }

  doFileAttachForAnalysis(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.movimientoService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {

            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                this.doAnalisisDocumento(data.Result.Archivos[0]);
              }
            }

          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir el archivo", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

  doAnalisisDocumento(adjunto: MovimientoAdjunto) {
    if (adjunto.UrlDocumento !== null) {
      var r = new SaveMovimientoFromDocumentRequestDto([ adjunto.UrlDocumento ]);
      this.isFileAnalyzing = true;

      this.movimientoService.generarDesdeDocumentos(r).subscribe(data => {
        this.isFileAnalyzing = false;
        if (data != null && data.Success && data.Result != null && data.Result.Movimientos != null && data.Result.Movimientos.length > 0) {
          var movAnalizado = data.Result.Movimientos[0] as any;

          if (movAnalizado != null && movAnalizado.Success) {
            this.formGroup.patchValue(movAnalizado);

            if (this.item.Adjuntos == null)
              this.item.Adjuntos = [];
            this.item.Adjuntos.push(adjunto);

            this.onMontoBaseChange();
            this.onAlicuotaIvaSelect();
            this.onMedioPagoSelect();
            this.onMonedaSelect();

            if (movAnalizado.AlicuotaIvaId == null)
              this.selectAlicuotaIvaDefault();

            if (movAnalizado.MedioPagoId == null)
              this.selectMedioPagoDefault();

            if (movAnalizado.MonedaId == null)
              this.selectMonedaDefault();

            if (movAnalizado.TipoMovimientoId == null)
              this.selectTipoMovimientoDefault();
          }
          else
            this.sharedFunctions.showMessage("Ocurrió un error intentando analizar el archivo " + movAnalizado.NombreDocumento + (movAnalizado?.MensajeError?.length > 0 ? ": "+movAnalizado?.MensajeError : ""), "Error");
        }
        else
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando analizar el archivo", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isFileAnalyzing = false;
        this.sharedFunctions.handleError(err, true);
      })
    }

  }

  contextMenuOpen(args: any): void {
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items,args.event.target, this.deudasPendientesGrid, this.gridColumns);
  }

  contextMenuClick(args: MenuEventArgs): void {
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.deudasPendientesGrid, this.gridColumns)
  }
}
